const DATES = {
  months: [
    { number: '01', monthName: 'January', days: 31 },
    { number: '02', monthName: 'February', days: 29 },
    { number: '03', monthName: 'March', days: 31 },
    { number: '04', monthName: 'April', days: 30 },
    { number: '05', monthName: 'May', days: 31 },
    { number: '06', monthName: 'June', days: 30 },
    { number: '07', monthName: 'July', days: 31 },
    { number: '08', monthName: 'August', days: 31 },
    { number: '09', monthName: 'September', days: 30 },
    { number: '10', monthName: 'October', days: 31 },
    { number: '11', monthName: 'November', days: 30 },
    { number: '12', monthName: 'December', days: 31 },
  ],
};

const STATES = {
  states: [
    {
      name: 'Armed Forces Americas',
      code: 'AA',
    },
    {
      name: 'Armed Forces Europe',
      code: 'AE',
    },
    {
      name: 'Alabama',
      code: 'AL',
    },
    {
      name: 'Armed Forces Pacific',
      code: 'AP',
    },
    {
      name: 'Alaska',
      code: 'AK',
    },
    {
      name: 'American Samoa',
      code: 'AS',
    },
    {
      name: 'Arizona',
      code: 'AZ',
    },
    {
      name: 'Arkansas',
      code: 'AR',
    },
    {
      name: 'California',
      code: 'CA',
    },
    {
      name: 'Colorado',
      code: 'CO',
    },
    {
      name: 'Connecticut',
      code: 'CT',
    },
    {
      name: 'Delaware',
      code: 'DE',
    },
    {
      name: 'District Of Columbia',
      code: 'DC',
    },
    {
      name: 'Federated States Of Micronesia',
      code: 'FM',
    },
    {
      name: 'Florida',
      code: 'FL',
    },
    {
      name: 'Georgia',
      code: 'GA',
    },
    {
      name: 'Guam',
      code: 'GU',
    },
    {
      name: 'Hawaii',
      code: 'HI',
    },
    {
      name: 'Idaho',
      code: 'ID',
    },
    {
      name: 'Illinois',
      code: 'IL',
    },
    {
      name: 'Indiana',
      code: 'IN',
    },
    {
      name: 'Iowa',
      code: 'IA',
    },
    {
      name: 'Kansas',
      code: 'KS',
    },
    {
      name: 'Kentucky',
      code: 'KY',
    },
    {
      name: 'Louisiana',
      code: 'LA',
    },
    {
      name: 'Maine',
      code: 'ME',
    },
    {
      name: 'Marshall Islands',
      code: 'MH',
    },
    {
      name: 'Maryland',
      code: 'MD',
    },
    {
      name: 'Massachusetts',
      code: 'MA',
    },
    {
      name: 'Michigan',
      code: 'MI',
    },
    {
      name: 'Minnesota',
      code: 'MN',
    },
    {
      name: 'Mississippi',
      code: 'MS',
    },
    {
      name: 'Missouri',
      code: 'MO',
    },
    {
      name: 'Montana',
      code: 'MT',
    },
    {
      name: 'Nebraska',
      code: 'NE',
    },
    {
      name: 'Nevada',
      code: 'NV',
    },
    {
      name: 'New Hampshire',
      code: 'NH',
    },
    {
      name: 'New Jersey',
      code: 'NJ',
    },
    {
      name: 'New Mexico',
      code: 'NM',
    },
    {
      name: 'New York',
      code: 'NY',
    },
    {
      name: 'North Carolina',
      code: 'NC',
    },
    {
      name: 'North Dakota',
      code: 'ND',
    },
    {
      name: 'Northern Mariana',
      code: 'MP',
    },
    {
      name: 'Ohio',
      code: 'OH',
    },
    {
      name: 'Oklahoma',
      code: 'OK',
    },
    {
      name: 'Oregon',
      code: 'OR',
    },
    {
      name: 'Palau',
      code: 'PW',
    },
    {
      name: 'Pennsylvania',
      code: 'PA',
    },
    {
      name: 'Puerto Rico',
      code: 'PR',
    },
    {
      name: 'Rhode Island',
      code: 'RI',
    },
    {
      name: 'South Carolina',
      code: 'SC',
    },
    {
      name: 'South Dakota',
      code: 'SD',
    },
    {
      name: 'Tennessee',
      code: 'TN',
    },
    {
      name: 'Texas',
      code: 'TX',
    },
    {
      name: 'Utah',
      code: 'UT',
    },
    {
      name: 'Vermont',
      code: 'VT',
    },
    {
      name: 'U.S. Virgin Islands',
      code: 'VI',
    },
    {
      name: 'Virginia',
      code: 'VA',
    },
    {
      name: 'Washington',
      code: 'WA',
    },
    {
      name: 'West Virginia',
      code: 'WV',
    },
    {
      name: 'Wisconsin',
      code: 'WI',
    },
    {
      name: 'Wyoming',
      code: 'WY',
    },
  ],
};

const ERROR_CODES = {
  sessionOutErrorCodes: ['45001', '18050', '02012', '02011', '02012'],
  globalErrorCodes: ['1046'],
  signInErrorCodes: [
    // 18xxx series
    '18002',
    '18003',
    '18004',
    '18005',
    '18027',
    '18116',
    '18118',
    '18202',
    '18203',
    '18204',
    '18205',
    '18206',
    '18207',
    '18208',
    '18209',
    '18210',
    '18211',
    '18212',
    '18213',
    // 19xxx series
    '19002',
    '19003',
    '19004',
    '19005',
    '19027',
    '19116',
  ],
};

const MACYS_ONLINE_UID = 'macys_online_uid';
const MACYS_ONLINE_GUID = 'macys_online_guid';
const SECURE_USER_TOKEN = 'secure_user_token';
const MAINTENANCE_ALERT = 'Maintenance Alert';

const CARD_TYPES = {
  Y: "Macy's",
  B: "Macys's American Express",
  A: 'American Express',
  V: 'Visa',
  M: 'MasterCard',
  O: 'Discover',
  F: 'Employee Card',
};
export { DATES, STATES, ERROR_CODES, MACYS_ONLINE_UID, MACYS_ONLINE_GUID, SECURE_USER_TOKEN, MAINTENANCE_ALERT, CARD_TYPES };
